<template>
  <div class="customer">
    <div class="box">
      <div class="columns">
        <div class="column is-9">
          <p class="title has-text-primary">
            {{ $store.state.customers.rfc }}
          </p>
          <p class="title has-text-primary">
            {{ $store.state.customers.name }}
          </p>
          <div class="buttons">
            <div class="field is-grouped">
              <p class="control">
                <a
                  class="button is-primary"
                  @click="sendStatusAccountEmail(
                    $store.state.customers.id,
                    $store.state.customers.companyId
                  )"
                >
                  <BIcon icon="send" />
                  <span> Enviar estado de cuenta</span>
                </a>
              </p>
              <p class="control">
                <RouterLink
                  class="button is-illuminating-emerald"
                  :to="{ name: 'NewInvoice' }"
                >
                  <BIcon
                    icon="bank"
                  />
                  <span>
                    Crear factura
                  </span>
                </RouterLink>
              </p>
            </div>
          </div>
        </div>
        <div class="column level-right">
          <div class="columns">
            <div class="column">
              <p class="title is-4 has-text-primary level-left">
                Deuda total
              </p>
            </div>
            <div class="column">
              <p
                v-for="debt in $store.state.customers.debtsCustomer"
                :key="debt._id.customer"
                class="is-4 title has-text-info level-left"
              >
                {{ debt.totalAmount | toCurrency(debt._id.currency) }}
              </p>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <p class="title is-4 has-text-primary level-left">
                Deuda vencida
              </p>
            </div>
            <div class="column">
              <p
                v-for="debt in $store.state.customers.debtsExpired"
                :key="debt._id.customer"
                class="title is-4 has-text-danger level-left"
              >
                {{ debt.totalAmount | toCurrency(debt._id.currency) }}
              </p>
            </div>
          </div>

          <div
            v-if="$store.state.customers.creditLimit > 0"
            class="columns"
          >
            <div class="column">
              <p class="title is-4 has-text-primary level-left">
                Crédito disponible
              </p>
            </div>
            <div class="column">
              <p
                v-for="debt in $store.state.customers.debtCreditLimit"
                :key="debt._id.customer"
                class="is-4 title has-text-info level-left"
              >
                {{ $store.state.customers.creditLimit-debt.totalAmount | toCurrency('MXN') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="columns is-multiline">
      <div class="column is-5">
        <div class="box">
          <form
            @submit.prevent="update"
          >
            <section class="modal-card-body">
              <div class="columns is-multiline">
                <div class="column is-12">
                  <Customer
                    v-if="loaded"
                    :loading="loading"
                  />
                </div>
              </div>

              <BLoading
                :is-full-page="false"
                :active.sync="loading"
              />
            </section>

            <div class="is-flex button-container">
              <button
                type="submit"
                class="button is-primary"
              >
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="column">
        <div class="box comments-wrapper">
          <IssoComments
            v-if="loaded"
            class="box"
            :loading="loading"
          />
        </div>
      </div>
    </div>
    <InvoicesHistory />
    <footer class="modal-card-foot">
      <RouterLink
        class="button"
        :to="{ name: 'Customers' }"
      >
        Regresar
      </RouterLink>
    </footer>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'EditCustomer',

  components: {
    Customer: () => import(/* webpackChunkName: "new-customer" */ '@/components/Admin/Customer/Edit.vue'),
    IssoComments: () => import(/* webpackChunkName: "customers-invoices-history" */ '@/components/Isso/Isso.vue'),
    InvoicesHistory: () => import(/* webpackChunkName: "customers-invoices-history" */ '@/components/Admin/Customer/InvoicesHistory.vue'),
  },

  data() {
    return {
      loaded: false,
      loading: false,
    };
  },

  computed: {
    debtsExpired() {
      return this.$store.state.customers.debtsExpired;
    },
  },

  beforeRouteEnter(to, from, next) {
    if (to.query.page) next();
    else {
      next({ ...to, query: { page: 1, size: 20 } });
    }
  },

  async beforeRouteUpdate(to, from, next) {
    await this.$store.dispatch('invoices/getAll', {
      ...to.query,
      'operation.customer': this.$route.params.customer,
    });

    next();
  },

  async mounted() {
    this.loading = true;
    await Promise.all([
      this.$store.dispatch('customers/getSingle', this.$route.params.customer),
      this.$store.dispatch('invoices/getAll', {
        ...this.$route.query,
        'operation.customer': this.$route.params.customer,
      }),
    ]);

    this.loading = false;
    this.loaded = true;
  },

  beforeRouteLeave(to, from, next) {
    if (to.name === 'NewInvoice') {
      const { creditDays } = this.$store.state.customers;
      const Days = creditDays > 0 ? creditDays : 1;
      const expirationDate = moment().add(Days, 'days').toDate();
      this.$store.commit('users/setValues', {
        name: this.$store.state.customers.name,
        email: this.$store.state.customers.email,
        rfc: this.$store.state.customers.rfc,
        companyName: this.$store.state.customers.companyName,
      });

      this.$store.commit('invoice/setValues', {
        receiverName: this.$store.state.customers.companyName,
        receiverRfc: this.$store.state.customers.rfc,
        'operation.expirationDate': expirationDate,
      });
    } else {
      this.$store.commit('customers/setValues', {
        name: '',
        email: '',
        rfc: '',
        companyName: '',
      });
    }
    next();
  },

  methods: {
    async update(event) {
      event.stopPropagation();
      this.loading = true;
      try {
        await this.$store.dispatch('customers/update');
        this.$success({ message: 'El cliente se actualizó exitosamente' });
        this.$router.push({ name: 'Customers' });
      } catch (error) {
        this.$danger({ message: error.message });
      }
      this.loading = false;
    },

    async sendStatusAccountEmail(customerId, companyId) {
      const now = new Date();

      this.$store.commit('ui/addNotification', {
        type: 'info',
        content: 'Enviando Estado de Cuenta...',
        dateTime: now,
      });

      await this.$store.dispatch(
        'customers/sendStatusAccountEmail',
        { customerId, companyId },
      );

      this.$store.commit('ui/deleteNotification', now);

      this.$store.dispatch('addTemporalNotification', {
        type: 'success',
        content: 'El estado de cuenta se envió correctamente.',
      });
    },
  },
};
</script>

<style scoped>
form {
  width: auto;
}

h1.title.has-text-primary {
  margin-bottom: 0;
  padding-bottom: .5rem;
}

.params:not(:last-child) {
  padding-bottom: 2.5rem;
}

.column.is-8.is-flex.is-centered {
  flex-direction: column;
}

.column.is-4 {
  display: flex;
}

.customer {
  padding: 1rem;
}

h5.title {
  margin: 0;
  padding-bottom: .5rem;
}

.box {
  height: 100%;
}

.box.comments-wrapper {
  height: auto;
}

.is-flex.button-container {
  justify-content: flex-end;
  padding-top: 1.5rem;
}
</style>
